<template>
  <div>
    <Row type="flex" :space-x="10" class="margin-right-left padding-top">
      <Cell>
        <Select v-model="params.accountId" :datas="accountList" keyName="id" titleName="name" :width="150"
                placeholder="全部账户"></Select>
      </Cell>
      <Cell>
        <div class="h-input-group" v-width="350">
          <DatePicker v-model="params.start" style="width: 140px" :clearable="false" :option="{end:params.end}"
                      format="YYYY-MM-DD"></DatePicker>
          <span class="h-input-addon">至</span>
          <DatePicker v-model="params.end" style="width: 140px" :clearable="false" :option="{start:params.start}"
                      format="YYYY-MM-DD"></DatePicker>
        </div>
      </Cell>
      <Cell>
        <Button color="primary" icon="fa fa-search" :loading="loading" @click="doSearch">查询</Button>
        <Button color="primary" @click="add">新增</Button>
      </Cell>
    </Row>
    <div class="h-panel-body padding-top">
      <Table :datas="journalList" :border="true" :loading="loading">
        <TableItem title="日期" :width="110">
          <template slot-scope="{data}">
            {{ data.billDate }}
          </template>
        </TableItem>
        <TableItem title="账户" prop="accountName" :width="120"></TableItem>
        <TableItem title="分类" prop="categoryName" :width="120"></TableItem>
        <TableItem title="收支" :width="70" align="center">
          <template slot-scope="{data}">
            <span :class="data.direction === 1 ? 'h-tag h-tag-bg-red' : 'h-tag h-tag-bg-green'">
              {{ data.direction === 1 ? '收入' : '支出' }}
            </span>
          </template>
        </TableItem>
        <TableItem title="金额" :width="130" align="right">
          <template slot-scope="{data}">
            {{ data.amount | numFormat }}
          </template>
        </TableItem>
        <TableItem title="余额" :width="130" align="right">
          <template slot-scope="{data}">
            {{ data.balance | numFormat }}
          </template>
        </TableItem>
        <TableItem title="摘要" prop="summary"></TableItem>
        <TableItem title="凭证" :width="80" align="center">
          <template slot-scope="{data}">
            <span class="h-tag h-tag-bg-blue" v-if="data.voucherId">已生成</span>
            <span v-else>-</span>
          </template>
        </TableItem>
        <TableItem title="操作" :width="160">
          <div class="actions" slot-scope="{data}">
            <span @click="generateVoucher(data)" v-if="!data.voucherId">生成凭证</span>
            <span @click="edit(data)">编辑</span>
            <span @click="remove(data)" v-if="!data.voucherId">删除</span>
          </div>
        </TableItem>
      </Table>
      <Pagination style="margin-top: 10px;" v-model="pagination" layout="total,sizes,pager,jumper"
                  @change="currentChange" small align="right"/>
    </div>

    <!--新增/编辑弹窗-->
    <Modal v-model="showForm" type="drawer-right" hasCloseIcon>
      <div slot="header">资金日记账</div>
      <Form ref="form" v-width="420" :labelWidth="100" :model="form" :rules="validationRules">
        <FormItem label="账户" prop="accountId">
          <Select v-model="form.accountId" :datas="accountList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="日期" prop="billDate">
          <DatePicker type="date" v-model="form.billDate" format="YYYY-MM-DD"></DatePicker>
        </FormItem>
        <FormItem label="收支方向" prop="direction">
          <Select v-model="form.direction" :datas="directionList" keyName="id" titleName="name"
                  @change="directionChange"></Select>
        </FormItem>
        <FormItem label="分类" prop="categoryId">
          <Select v-model="form.categoryId" :datas="formCategoryList" keyName="id" titleName="name"></Select>
        </FormItem>
        <FormItem label="金额" prop="amount">
          <NumberInput :min="0.01" v-model="form.amount"></NumberInput>
        </FormItem>
        <FormItem label="摘要" prop="summary">
          <input type="text" v-model="form.summary">
        </FormItem>
      </Form>
      <div class="text-center">
        <Button color="green" @click="submit" :loading="loading">{{form.id?'更新':'保存'}}</Button>
        <Button @click="showForm=false" :loading="loading">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import moment from 'moment';

const emptyForm = {
  accountId: null,
  billDate: null,
  direction: 2,
  categoryId: null,
  amount: null,
  summary: ''
};

export default {
  name: "FundsJournal",
  data() {
    return {
      accountList: [],
      categoryList: [],
      directionList: [{id: 1, name: '收入'}, {id: 2, name: '支出'}],
      journalList: [],
      params: {
        accountId: null,
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD')
      },
      pagination: {
        page: 1,
        size: 20,
        total: 0
      },
      form: Object.assign({}, emptyForm),
      validationRules: {
        required: ['accountId', 'billDate', 'direction', 'categoryId', 'amount']
      },
      showForm: false,
      loading: false
    }
  },
  computed: {
    formCategoryList() {
      return this.categoryList.filter(val => val.direction === this.form.direction);
    }
  },
  methods: {
    loadList() {
      this.loading = true;
      this.$api.funds.journal.list(Object.assign({}, this.params, {
        page: this.pagination.page,
        pageSize: this.pagination.size
      })).then(({data}) => {
        this.journalList = data.results || [];
        this.pagination.total = data.total || 0;
      }).finally(() => this.loading = false);
    },
    loadBase() {
      Promise.all([
        this.$api.funds.account.list(),
        this.$api.funds.category.list()
      ]).then((results) => {
        this.accountList = results[0].data || [];
        this.categoryList = results[1].data || [];
      });
    },
    doSearch() {
      this.pagination.page = 1;
      this.loadList();
    },
    currentChange() {
      this.loadList();
    },
    directionChange() {
      this.form.categoryId = null;
    },
    add() {
      this.form = Object.assign({}, emptyForm, {billDate: moment().format('YYYY-MM-DD')});
      this.showForm = true;
    },
    edit(data) {
      this.form = Object.assign({}, data);
      this.showForm = true;
    },
    submit() {
      let validResult = this.$refs.form.valid();
      if (validResult.result) {
        this.loading = true;
        let data = Object.assign({}, this.form);
        if (data.billDate) {
          data.billDate = moment(data.billDate).format('YYYY-MM-DD');
        }
        this.$api.funds.journal[data.id ? 'update' : 'save'](data).then(() => {
          this.$Message('保存成功~');
          this.showForm = false;
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      }
    },
    generateVoucher(data) {
      this.$Confirm(`确认为该笔记录生成凭证？`).then(() => {
        this.loading = true;
        this.$api.funds.journal.generateVoucher(data.id).then(() => {
          this.$Message('凭证生成成功~');
          this.loadList();
        }).catch(() => {
        }).finally(() => this.loading = false);
      })
    },
    remove(data) {
      this.$Confirm("确认删除?").then(() => {
        this.$api.funds.journal.delete(data.id).then(() => {
          this.loadList();
        })
      })
    }
  },
  mounted() {
    this.loadBase();
    this.loadList();
  }
}
</script>
